import React from 'react';
import {connect} from 'react-redux';
import AppActions from '../AppActions';
import {Link} from 'react-router-dom';
import {history} from '../store';
const mapStateToProps = (state) => {
    return {
      language: state.application.language
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
      switchLanguage: (language) => dispatch(AppActions.switchLanguage(language)),
      loadLanguagePackage: (language) => dispatch(AppActions.loadLanguagePackage(language)),
      setToken:(token) => dispatch(AppActions.setToken(token))
    }
};

class LanguageChooser extends React.Component {
    constructor(props){
      super(props);
      this.handleClick = this.handleClick.bind(this);
      console.log(props);
      this.changeRoute = this.changeRoute.bind(this);
    }

    handleClick(e, language){
        console.log(this.props.data.data.location);
        this.props.switchLanguage(language);
        this.props.loadLanguagePackage(language);
    }

    changeRoute(){

        return this.props.data.data.location.pathname.split("/")[2];
    }

    render() {
        this.changeRoute();
        return (
            <div className="float-right">
              <span style={{fontSize: "0.8em"}}>{this.props.language.active !== "de" ? "English" : "Deutsch"}</span>&nbsp;
                <Link to={"/de/" + this.props.data.data.match.url.split("/")[2] + "/" + this.props.data.data.match.params.token} className={this.props.language.active === "de" ? "lang-icon lang-icon-active flag-icon flag-icon-de" : "lang-icon flag-icon flag-icon-de"} onClick={(e) => this.handleClick(e,"de")}/>&nbsp;
                <Link to={"/en/" + this.props.data.data.match.url.split("/")[2] + "/" + this.props.data.data.match.params.token} className={this.props.language.active === "en" ? "lang-icon lang-icon-active flag-icon flag-icon-gb" : "lang-icon flag-icon flag-icon-gb"} onClick={(e) => this.handleClick(e, "en")}/>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageChooser);



// WEBPACK FOOTER //
// ./src/components/LanguageChooser.js